// Filename: public/manageHeader.js

import wixLocationFrontend from 'wix-location-frontend';
import { authentication } from 'wix-members-frontend';
import { orders } from 'wix-pricing-plans';

let nonIncludePlans = ['App Paid Membership', 'App Lifetime Membership'];

export function handleDonateBtnLink() {
    $w('#headerDonateBtn, #mobHeaderDonateBtn').link = '/donate';
    $w('#headerDonateBtn, #mobHeaderDonateBtn').target = '_self';
}

export async function handleUpgradeMembershipBtn() {

    const isLoggedIn = await authentication.loggedIn(); // Check if the user is currently logged in

    if (isLoggedIn) {

        if (wixLocationFrontend.url.includes("plans-pricing")) {
            $w('#headerUpgradeMembershipBtn').collapse();
            return;
        }

        await getCurrentMembersOrders();

    }
}

async function getCurrentMembersOrders() {
    orders.listCurrentMemberOrders({ 'orderStatuses': ['ACTIVE'] })
        .then((ordersList) => {
            let allActivePlans = [];
            if (ordersList && ordersList.length != 0) {
                ordersList.forEach((order) => {
                    if (order.planName != `Donation` && !order.cancellation) {
                        allActivePlans.push(order);
                    }
                });
            }

            console.log("All Active Plans", allActivePlans);

            allActivePlans = allActivePlans.filter(e => !nonIncludePlans.includes(e.planName));
            console.log("Filtered Active Plans", allActivePlans);

            redirectToMembershipPage(allActivePlans);

        })
        .catch((error) => {
            console.error(error);
        })
}

async function redirectToMembershipPage(memberships) {

    const highestPlanIds = new Set([
        '85cdb2f8-93c4-4a28-b805-827d128457ba',
        '3c5751f2-26f5-44e0-a05e-242207f10044',
        'a710b807-84fd-4d9e-bde5-083a81569175',
        '4caea5c6-0127-4dbe-b080-07ee26e22026',
        '1da72b59-a377-4fcf-8f01-c53a1b4e22db',
        '150bd1df-b89a-43f8-94b5-c71fc99389e5'
    ]);

    const planRedirects = [{
            ids: ['9143d12e-b5f6-4fac-9379-a0cfdcd2d2f1', '135a502d-4e1b-41d8-b1d4-ec9a72c8da9a', '85cdb2f8-93c4-4a28-b805-827d128457ba'],
            url: '/monthly-membership'
        },
        {
            ids: ['c4404d01-2ddf-4391-9304-a96c00463b28', '29db707a-7e00-40bd-bea3-09897471c7a2', '3c5751f2-26f5-44e0-a05e-242207f10044'],
            url: '/membership-for-coaches'
        },
        {
            ids: ['2c7530f6-e337-4a02-9832-cb6534d1e5da', '2b95e878-c9b4-4bee-8a86-258450f31b7e', 'a710b807-84fd-4d9e-bde5-083a81569175'],
            url: '/membership-for-icf-coaches'
        },
        {
            ids: ['2fad4ad1-2cf3-4af8-a956-721fcd1bd507', '58330b30-f2b7-4030-948a-719ce0593abe', 'cebdb2d1-011d-49ac-8519-403b277b833d', '4caea5c6-0127-4dbe-b080-07ee26e22026'],
            url: '/membership-for-partners'
        },
        {
            ids: ['1e6c981e-d1f9-417f-b31f-6b667476247c', '45df1678-26e7-44d5-80f6-c5a0b7aade1d', 'cb1769a5-bf3f-4a65-8ed1-941c01d1ae17', '1da72b59-a377-4fcf-8f01-c53a1b4e22db'],
            url: '/membership-for-nonprofits'
        },
        {
            ids: ['ec720764-7ef3-4bbf-b069-689c3bd0e9b3', '150bd1df-b89a-43f8-94b5-c71fc99389e5'],
            url: '/membership-for-wfdp'
        }
    ];

    // Hide the button if user has a highest plan
    if (memberships.some(plan => highestPlanIds.has(plan.planId))) {
        $w('#headerUpgradeMembershipBtn, #mobHeaderUpgradeMembershipBtn').collapse();
    }

    if (memberships.length === 0) {
        $w('#headerUpgradeMembershipBtn, #mobHeaderUpgradeMembershipBtn').link = '/monthly-membership';
        $w('#headerUpgradeMembershipBtn, #mobHeaderUpgradeMembershipBtn').expand();
        return;
    }

    // Sort and get latest active plan
    const latestPlan = [...memberships].sort((a, b) => b.startDate - a.startDate)[0];
    console.log('latestPlan', latestPlan);

    // Use .find() to locate matching plan redirect
    const match = planRedirects.find(group => group.ids.includes(latestPlan.planId));
    console.log('match', match);

    $w('#headerUpgradeMembershipBtn, #mobHeaderUpgradeMembershipBtn').link = match?.url || '/monthly-membership';
    $w('#headerUpgradeMembershipBtn, #mobHeaderUpgradeMembershipBtn').expand();

}